module.exports = __webpack_public_path__ + "img/GH-kyujin-top-011.fd781ed7.webp";